import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationTriangle,
} from "@fortawesome/pro-solid-svg-icons";
import styled, { useTheme } from "styled-components";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

export const DataStatusTriangle = styled.div`
  position: absolute;
  bottom: -2px;
  right: -9px;
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 9px 16px 9px;
  border-color: transparent transparent ${(props) => props.theme.colors.white}
    transparent;
`;

export const DataStatusCircle = styled.div`
  position: absolute;
  bottom: -2px;
  right: -9px;
  width: 15px;
  height: 15px;
  border-radius: 10px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const DataStatusWarningIcon = styled(FontAwesomeIcon)`
  position: absolute;
  left: -5px;
`;

const DataStatusSuccessIcon = styled(FontAwesomeIcon)`
  width: 12px;
  margin-bottom: 10px;
  margin-left: 2px;
`;

type DataStatusProps = {
  size?: SizeProp;
  className?: string;
  noIconOnComplete?: boolean;
  missingData: boolean;
  titleMissing?: string;
  titleComplete?: string;
};

const DataStatus = (props: DataStatusProps): JSX.Element | null => {
  const { t } = useTranslation("employees");
  const theme = useTheme();
  const titleMissing =
    props.titleMissing ?? t("employee.status.incomplete.title");
  const titleComplete =
    props.titleComplete ?? t("employee.status.complete.title");

  if (props.missingData) {
    return (
      <DataStatusTriangle className={props.className} title={titleMissing}>
        <DataStatusWarningIcon
          size={props.size}
          icon={faExclamationTriangle}
          color={theme.colors.accent3}
        />
      </DataStatusTriangle>
    );
  }

  if (props.noIconOnComplete) {
    return null;
  }

  return (
    <DataStatusCircle className={props.className} title={titleComplete}>
      <DataStatusSuccessIcon
        size={props.size}
        icon={faCheckCircle}
        color={"green"}
      />
    </DataStatusCircle>
  );
};

export default DataStatus;
